module.exports = __webpack_public_path__ + "static/media/ignor.987f0b6f.svg";